import { AIRWORTHY_STATUSES } from '../../../../constants';

import { WithPopover } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import AirworthyMenu from './components/AirworthyMenu';
import AirworthyPill from './components/AirworthyPill';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props, ReadinessLabelMap } from './types';

import styles from './styles.module.scss';

const AirworthyControl: FunctionComponent<Props> = ({
    className = '',
    droneId,
    isAdmin,
    onSetAirworthy,
    readiness,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const readinessLabels: ReadinessLabelMap = {
        grounded: t.READINESS_GROUNDED,
        hold: t.READINESS_HOLD,
        ready: t.READINESS_READY
    };
    const handleStop = (clickEvent: { stopPropagation: VoidFunction }) =>
        clickEvent.stopPropagation();
    const pill = <AirworthyPill label={readinessLabels[readiness]} readiness={readiness} />;

    return (
        <div
            className={`${styles.airworthyControl} ${className}`}
            data-testid={testId}
            onClick={handleStop}>
            {isAdmin ? (
                <WithPopover className={styles.popover} trigger={pill}>
                    <AirworthyMenu
                        onSelect={status => onSetAirworthy({ droneId, status })}
                        readinessLabels={readinessLabels}
                        statuses={AIRWORTHY_STATUSES}
                    />
                </WithPopover>
            ) : (
                pill
            )}
        </div>
    );
};

export default AirworthyControl;
